export default __webpack_public_path__ + "static/media/golden-pg2.c09f8fd1.png";